site.adverts = {
	init: function() {
		if($('#region_id').val() != 6) {
			$('[id^=colorpicker]').addClass('hide');
		}
		$('#region_id').change(function() {
			if($(this).val() != 6) {
				$('[id^=colorpicker]').addClass('hide');
			}
			else {
				$('[id^=colorpicker]').removeClass('hide');
			}
		});
	}
};